import {
  Avatar,
  Badge,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import DownIcon from "@material-ui/icons/KeyboardArrowDown";
import PersonOutlineOutlined from "@material-ui/icons/PersonOutlineOutlined";
import * as registry from "@qpr/client-api-registry";
import { UserInfo, useAuth, useCurrentTenant } from "@qpr/client-library";
import clsx from "clsx";
import { t } from "i18next";
import { System } from "qpr-base/configuration/index";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useCurrentUser from "qpr-base/context/UserContext";
import { clearElementCache } from "qpr-base/querybuilder/ElementCache";
import HorizontalMenu from "qpr-base/ui/HorizontalMenuView";
import AppBar from "qpr-base/viewcomponents/AppBar/AppBar";
import ApplicationToolBar from "qpr-base/viewcomponents/ApplicationToolBar/ApplicationToolBar";
import Flex from "qpr-base/viewcomponents/Flex/Flex";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React, { useEffect, useRef } from "react";
import { useQueryClient } from "react-query";
import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import useNotificationBell from "../../backend/hooks/workflows/useNotificationBell";
const styles = makeThemedStyles("AppBar.Icons", (theme) => ({
  iconButton: {
    width: "20px",
    height: "20px",
    marginLeft: "15px",
    marginRight: "15px",
  },
  avatarButton: {
    width: "20px",
    height: "20px",
    marginLeft: "35px",
    marginRight: "35px",
    color: "#F5F5F6",
  },
  avatarIcon: {
    width: "38px",
    height: "38px",
    color: "white",
    backgroundColor: "rgb(183, 186, 187)",
  },
  appBarLeftSide: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "70%",
    overflow: "hidden",
  },
  planContainer: {
    width: "15em",
    height: "4.457em",
    backgroundColor: "rgba(16, 73, 80, 1)",
    borderRadius: "2.285em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0px 1.14em 0px 1.14em",
    transition: "left 0.5s",
  },
  planText: {
    fontSize: "1.37em",
    lineHeight: "20.26px",
  },
  toToggleMove: {
    left: "450px",
  },
}));
const userUserMenuStyles = makeThemedStyles("AppBar.UserMenu", (theme) => ({
  card: {
    zIndex: 999999999,
    fontSize: "1.142em",
    width: "27.3em",
    display: "flex",
    flexDirection: "column",
    borderRadius: "1em",
    position: "absolute",
    top: "5.9em",
    overflow: "visible",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-4px",
      right: "1.551em",
      width: 0,
      height: 0,
      borderLeft: "4px solid transparent",
      borderRight: "4px solid transparent",
      borderBottom: "4px solid #fff",
    },
  },
  cardRTL: {
    left: "368px",
    "&::after": {
      right: "unset",
      left: "1.551em",
    },
  },
  actions: {
    height: "4em",
    marginTop: "auto",
    background: "rgba(196, 196, 196, 0.14)",
    padding: 0,
  },
  logout: {
    color: "rgb(14, 37, 106)",
    height: "100%",
    width: "100%",
    letterSpacing: "1.3px",
    fontSize: "1.2em",
    fontWeight: 700,
    padding: 0,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "0px",
  },
  avatar: {
    height: "2.56em",
    width: "2.56em",
  },
  avatarIcon: {
    width: "38px",
    height: "38px",
    color: "white",
    backgroundColor: "rgb(183, 186, 187)",
  },
  details: {
    margin: "0 1.2em",
  },
  name: {
    fontWeight: 500,
    fontSize: "1.6em",
    lineHeight: "1.25em",
    letterSpacing: "0.05px",
    color: "rgba(76, 81, 87, 1)",
  },
  email: {
    marginTop: "0.214em",
    letterSpacing: "0.05625px",
    fontSize: "1.4em",
    lineHeight: "1.428em",
    color: "rgb(6, 156, 240)",
  },
  section: {
    display: "flex",
    alignItems: "center",
    padding: "15px",
  },
  registerIcon: {
    width: "8.53px",
    height: "12.8px",
  },
  bordersec: {
    border: "1px solid rgba(0, 0, 0, 0.05)",
    justifyContent: "center",
    cursor: "pointer",
    width: "100%",
  },
}));
interface Tenant {
  symbol: string;
  metricsModelId: string;
  redirectUrl: string;
  landingUrl?: string;
  authMethod?: string;
  menuType?: string;
}
type IUserMenuCard = {
  logout: () => void;
  onClose: () => void;
  tenant: Tenant;
  user: UserInfo;
  parentRef: HTMLElement | null;
};
function UserMenuCard(props: IUserMenuCard) {
  const { logout, user, onClose, parentRef } = props;
  const classes = userUserMenuStyles();
  const { rtl, model } = useAppContext();
  const cardRef = useRef<HTMLElement>(null);
  const history = useHistory();
  const tenant = useCurrentTenant();
  const MobileIconOutlined = registry.getSvg("MobileIconOutlined");
  useEffect(() => {
    if (parentRef && cardRef.current) {
      const { left } = parentRef.getBoundingClientRect();
      cardRef.current.style.left = `${left - (rtl ? -9 : 88)}px`;
    }
  }, [parentRef]);
  useEffect(() => {
    function handler(e: any) {
      if (!parentRef?.contains(e.target)) {
        onClose();
      }
    }
    if (cardRef.current) {
      document.addEventListener("click", handler);
    }
    return () => {
      document.removeEventListener("click", handler);
    };
  }, [cardRef, parentRef]);
  return (
    <Card className={clsx(classes.card, rtl && classes.cardRTL)} ref={cardRef}>
      <CardContent className={classes.content}>
        <div className={classes.section}>
          <Avatar className={classes.avatarIcon}>
            <PersonOutlineOutlined fontSize="large" />
          </Avatar>
          <div className={classes.details}>
            <Typography className={classes.name}>{t(user.fullname)}</Typography>
            {user.email && (
              <Typography className={classes.email}>{t(user.email)}</Typography>
            )}
          </div>
        </div>
        {System.flags.mobileAppRegistration ? (
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              history.push(`/${tenant.symbol}/${model}/register/`);
              onClose();
            }}
            onKeyDown={() => history.push(`/tec/${model}/register/`)}
            className={clsx(classes.section, classes.bordersec)}
          >
            <MobileIconOutlined className={classes.registerIcon} />
            <div className={classes.details}>
              <Typography className={classes.name}>
                {t("Mobile Application Registration")}
              </Typography>
            </div>
          </div>
        ) : null}
      </CardContent>
      {props.tenant.authMethod === "ums" && (
        <CardActions className={classes.actions}>
          <Button variant="text" className={classes.logout} onClick={logout}>
            {t("Logout")}
          </Button>
        </CardActions>
      )}
    </Card>
  );
}
const BusinessPortalAppBar = () => {
  const userMenuAnchorEl = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const ctx = useAppContext();
  const classes = styles();
  const tenant: Tenant = useCurrentTenant();
  const user = useCurrentUser();
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const { logout } = useAuth();
  const queryClient = useQueryClient();
  const history = useHistory();
  const { hasNotification } = useNotificationBell();
  const handleAvatarClick = () => {
    setIsOpen((val) => !val);
  };
  const handleUserMenuClose = () => {
    setIsOpen(false);
  };
  const handleLogOutClick = async () => {
    handleUserMenuClose();
    const isLoggedOut = await logout();
    // @ts-ignore
    if (isLoggedOut) {
      await queryClient.invalidateQueries();
      clearElementCache();
      localStorage.removeItem("SelectedReport");
      history.push(`/${tenant.symbol}/`);
    }
  };
  const PlanSwitchButton = registry.getSvgIcon("PlanSwitchButton");

  return (
    <AppBar>
      <ApplicationToolBar style={{ height: "70px" }}>
        <div className={classes.appBarLeftSide}>
          <HorizontalMenu tenant={tenant.symbol} />
          <System.Toolbar.PlanSwitch />
          <System.Toolbar.Breadcrumb />
        </div>
        <Flex>
          {!pathname.includes("landingpage") && ctx.modelId && (
            <div className={clsx(classes.planContainer)}>
              <p className={classes.planText}>{t(ctx.modelId || "")}</p>
            </div>
          )}

          <System.Toolbar.SearchBar />

          <Link
            to={`/${ctx.tenant || "demo"}/${ctx.modelId}/mytasks`}
            style={{ textDecoration: "none" }}
          >
            <IconButton className={classes.iconButton}>
              <Badge
                color="secondary"
                badgeContent=" "
                variant="dot"
                overlap="circular"
                invisible={!hasNotification}
              >
                {System.icons.NotificationIcon}
                {/*
            <img src={getFileApiURL('/icons/TECNotificationCenter.svg')} alt="Notifications" />
          */}
              </Badge>
            </IconButton>
          </Link>
          <div ref={userMenuAnchorEl}>
            <IconButton
              className={classes.avatarButton}
              aria-controls="user-menu"
              aria-haspopup
              onClick={handleAvatarClick}
            >
              <Avatar className={classes.avatarIcon}>
                <PersonOutlineOutlined fontSize="large" />
              </Avatar>
              <DownIcon fontSize="large" />
            </IconButton>
            {isOpen && (
              <UserMenuCard
                tenant={tenant}
                parentRef={userMenuAnchorEl.current}
                logout={handleLogOutClick}
                onClose={handleUserMenuClose}
                user={user}
              />
            )}
          </div>
          <System.Toolbar.LanguageSwitchView />
          {System.icons.AppBarImage}
        </Flex>
      </ApplicationToolBar>
    </AppBar>
  );
};
export default BusinessPortalAppBar;
